import MasterCrud from "@/components/app/MasterCrud";
export default function EnvCategories() {
  return (
    <MasterCrud endpoint="/env-cost-categories" title="Kategori Biaya Lingkungan"
      description="Kelola kategori biaya lingkungan dan mode default: masuk HPP atau hanya untuk pelaporan."
      fields={[
        { key: "code", label: "Kode", type: "text", required: true },
        { key: "name", label: "Nama Kategori", type: "text", required: true },
        { key: "default_billing_mode", label: "Mode Default", type: "select", options: [
          { value: "hpp", label: "Dibebankan ke HPP" },
          { value: "report_only", label: "Hanya Pelaporan" },
        ], default: "hpp", required: true },
        { key: "description", label: "Deskripsi", type: "textarea" },
      ]}
    />
  );
}
